/**
 * Images live in `static/assets/`. Each slide uses `images: [keys…]` from ASSET_FILES.
 * Add or reorder keys to show multiple photos per slide.
 */
/** Maps each slide slot to a file in `static/assets/` (your filenames). */
export const ASSET_FILES = {
  /** Title slide — family and travel photos */
  cover: "Alex with wife Yuliia and Karat - their dog.jpg",
  /** Title slide — Alex, Yulia & Karat (mirror photo) */
  titleMirror: "Alex Yulia and Karat.jpg",
  titleYarkon: "Alex and Yuliia photo in Yarkon Park.jpg",
  titleTravelRiga: "Alex in Riga with Bremen musicians.jpg",
  titleTravelEilat: "Alex and Karat in Eilat.jpg",
  titleTravelAmbulance: "Alex is being loaded to the ambulence.jpg",
  spbBaltic: "Alex in nature in Saint Petersburg.jpg",
  spbNature: "Nature in Saint Petersburg.jpg",
  spbCinema: "cinema hall in saint petersburg.jpg",
  spbCity1: "saint petersburg.jpg",
  spbCity2: "Saint Petersburg 2.avif",
  spbCity3: "Saint Petersburg 3.webp",
  spbCity4: "Saint Petersburg 4.webp",
  spbCity5: "saint petersburg 5.jpg",
  spbCity6: "saint petersburg 6.jpg",
  spbCity7: "saint petersburg 7.jpg",
  mapPolandSpb: "map saint petersburg and poland.jpg",
  familyParents: "parents.jpg",
  familyGrandmother: "grandmother.jpg",
  familyMomSkis: "mom on skies.jpg",
  familyBrotherKarat: "brother with Karat.jpg",
  familyHeroRaceBrother: "hero race photo with brother.jpg",
  childhood: "Alex's home interrier in Saint Petersburg.jpg",
  hobbies: "Alex and padel.jpg",
  tennisRacket: "Alex with tennis racket.jpg",
  hobbyEnsemble: "ansamble with brother and other members.jpg",
  hobbyBadminton: "Alex and badminton.jpg",
  hobbyBasketball: "Alex playing basketball.jpg",
  hobbyHeroesRun: "Alex and heros run.jpg",
  hobbyRunning: "Alex and running photo.jpg",
  hobbyRunningMedal: "Alex and medal for running.jpg",
  hobbyMountainSki: "Alex and mountain ski.jpg",
  hobbyMountainSki2: "Alex and mountain ski 2.jpg",
  hobbyConcertCostume: "Alex before the concert in a costume.jpg",
  education: "saint-petersburgelectrotechnicaluniversityleti.jpg",
  itBackground: "Alex's view from the working place window.jpg",
  sysAdminMe: "me as a sys admin.jpeg",
  sysAdminServers: "servers of internal infrastracture.jpeg",
  sysAdminShell: "commutation shell for network admins.jpeg",
  sysAdminVc: "video conference preset for sys admins.jpeg",
  immigrationAirportSpb1: "saint petersburg airport.jpg",
  immigrationAirportSpb2: "saint petersburg airport 2.jpg",
  immigrationAirportSpb3: "saint petersburg airport 3.jpg",
  immigrationBoardingPlane: "boarding airplane to imigrate.jpg",
  immigrationMiddle2: "middle countries in imigration 2.jpg",
  immigrationMiddle3: "middle countries in imigration 3.jpg",
  israel: "Alex and Tel Aviv skyscrappers view.jpg",
  israelDeadSea: "Alex on a dead sea.jpg",
  ashkelonFirstMonths: "first months in Ashkelon.jpg",
  ashkelonMissile: "Ashkelon atacked by a missle.jpg",
  ashkelonMissile2: "Ashkelon atacked by a missle 2.jpg",
  ashkelonShelter: "Sleeping in Ashkelon in a bomb shelter.jpg",
  bootcamp: "Alex in London.jpg",
  developersInstitute: "developers institute.jpg",
  developersInstituteProject: "developers institute project.jpg",
  abilisensorApp: "abilisensor app.jpg",
  abilisensorApp2: "abilisensor app 2.jpg",
  abilisensorApp3: "abilisensor app 3.jpg",
  abilisensorApp4: "abilisensor app 4.jpg",
  payoneer: "Alex and CC collegues on Payoneer CJ fun day.jpg",
  payoneerVolunteer: "Alex with a dog from shelter on payoneer's volonteer day.jpg",
  digitalAi: "digitalaiteam doppler.jpg",
  useful: "employee of the year certificate.jpg",
  lifeOutside: "tennis rackets and dog.jpg",
  lifeAnimals: "Alex and animals.jpg",
  funClose: "Alex with dog lover tattoo and another dog.jpg",
  wedding: "Alex and Yulia wedding.jpg",
  optionalLife: "Alex injure photo.jpg",
};

export const PORTFOLIO_URL = "https://alexzborovsky.com";

export const SLIDES = [
  {
    id: "title",
    images: [
      "titleTravelEilat",
      "cover",
      "titleMirror",
      "titleTravelRiga",
      "titleYarkon",
      "titleTravelAmbulance",
    ],
    blocks: [
      {
        type: "title",
        text: "So... This is me. Alex",
        subtitle: "A presentation for the best team ever.\nHR violations may occur.",
      },
      {
        type: "contactStrip",
        portfolioUrl: PORTFOLIO_URL,
        instagramUrl: "https://www.instagram.com/alejasha/",
        instagramHandle: "@alejasha",
        email: "alexzborovskii@gmail.com",
        phoneDisplay: "+972 53 278 8241",
        whatsappUrl: "https://wa.me/972532788241",
        telegramUrl: "https://t.me/alejasha",
        telegramHandle: "alejasha",
      },
    ],
  },
  {
    id: "why",
    images: ["mapPolandSpb"],
    blocks: [
      {
        type: "title",
        text: "Why this presentation exists",
      },
      {
        type: "paragraphs",
        items: [
          "After the last meeting with Maciej, I realized my team barely knows anything about me 😄",
          "Since it looks like I’m staying with you for a while, it makes sense to finally fix that.",
          "Also… someone once asked if anyone here has seen the Baltic Sea.",
          "I grew up there.",
          "Yes. I’m still offended.",
        ],
      },
    ],
  },
  {
    id: "from",
    images: ["spbCity1", "spbCity2", "spbCity3", "spbCity4", "spbCity5", "spbCity6", "spbCity7"],
    blocks: [
      {
        type: "title",
        text: "Where I’m from",
      },
      {
        type: "paragraphs",
        items: [
          "I’m from Saint Petersburg, Russia.",
          "I was born and spent my first 28 years in the historical center.",
          "It’s a city on the shore of the Baltic Sea — now you know.",
        ],
      },
    ],
  },
  {
    id: "origins",
    images: [
      "familyParents",
      "familyGrandmother",
      "familyMomSkis",
      "familyBrotherKarat",
      "familyHeroRaceBrother",
    ],
    blocks: [
      {
        type: "title",
        text: "Origins & childhood",
      },
      {
        type: "paragraphs",
        items: [
          "I was raised in a same-gender family — my mother and grandmother (very typical for Russia).",
          "Since childhood I’ve had a lot of hobbies.",
          "Thanks, mom 🙂",
        ],
      },
    ],
  },
  {
    id: "hobbies",
    images: [
      "hobbyEnsemble",
      "hobbies",
      "hobbyRunning",
      "hobbyBadminton",
      "tennisRacket",
      "hobbyBasketball",
      "hobbyHeroesRun",
      "hobbyRunningMedal",
      "hobbyMountainSki",
    ],
    blocks: [
      {
        type: "title",
        text: "Too many hobbies",
        subtitle: "Just to name a few:",
      },
      {
        type: "columns",
        left: [
          {
            type: "bullets",
            items: [
              "10 years of music school",
              "3 years of dance school",
              "Basketball, tennis, badminton, table tennis",
            ],
          },
        ],
        right: [
          {
            type: "bullets",
            items: [
              "Football (some might say soccer)",
              "Padel, beach volleyball",
              "And probably many others — I’m not that young to remember everything",
            ],
          },
        ],
      },
    ],
  },
  {
    id: "education",
    images: ["education"],
    blocks: [
      {
        type: "title",
        text: "Education",
      },
      {
        type: "paragraphs",
        items: [
          "After school, I studied Nanotechnologies & Microsystems Engineering at university.",
          "Yes — sounds very serious 😄",
        ],
      },
    ],
  },
  {
    id: "it",
    images: [
      "itBackground",
      "sysAdminMe",
      "sysAdminServers",
      "sysAdminShell",
      "sysAdminVc",
    ],
    blocks: [
      {
        type: "title",
        text: "IT background",
        subtitle: "After university:",
      },
      {
        type: "bullets",
        items: [
          "Worked 9 years as an outsourced system administrator",
          "Multiple roles in IT support",
          "Production systems, real users, real pain",
        ],
      },
      {
        type: "paragraphs",
        items: ["This experience shaped how I approach problems today."],
      },
    ],
  },
  {
    id: "life-turn",
    images: [
      "wedding",
      "immigrationAirportSpb1",
      "immigrationAirportSpb2",
      "immigrationAirportSpb3",
      "immigrationBoardingPlane",
      "immigrationMiddle2",
      "immigrationMiddle3",
    ],
    blocks: [
      {
        type: "title",
        text: "Big life turn",
      },
      {
        type: "paragraphs",
        items: [
          "After the beginning of the full-scale war against Ukraine, we decided to get married and leave the country together.",
          "Soon after, mobilization started.",
          "I had to pack everything I could and leave within days.",
          "I spent a few months in middle countries on my own — my wife was handling the paperwork for us and for our dog.",
          "When everything was ready, we reunited — the three of us — and came to Israel together.",
        ],
      },
    ],
  },
  {
    id: "israel",
    images: [
      "ashkelonFirstMonths",
      "ashkelonMissile",
      "ashkelonMissile2",
      "ashkelonShelter",
      "israel",
      "israelDeadSea",
    ],
    blocks: [
      {
        type: "title",
        text: "Israel chapter",
      },
      {
        type: "paragraphs",
        items: [
          "Because of document issues, I spent ~3 months in transit countries on my own before we could all travel to Israel together.",
          "Then ~6 months as a tourist in Israel",
          "My first year in Israel I lived in Ashkelon, including several weeks around October 7.",
          "Eventually, both my wife and I became Israeli citizens — even though we had never been to Israel before.",
        ],
      },
    ],
  },
  {
    id: "bootcamp",
    images: ["developersInstitute", "developersInstituteProject"],
    blocks: [
      {
        type: "title",
        text: "Tech reboot",
        subtitle:
          "After becoming a citizen, I joined a full-time full-stack bootcamp (5 months, very intense).",
      },
      {
        type: "tags",
        title: "Skills I picked up:",
        items: [
          "JavaScript",
          "React / Next.js",
          "Node.js",
          "React Native",
          "Python",
          "SQL, MongoDB",
          "Git",
        ],
      },
    ],
  },
  {
    id: "startup",
    images: ["abilisensorApp", "abilisensorApp2", "abilisensorApp3", "abilisensorApp4"],
    blocks: [
      {
        type: "title",
        text: "Startup experience",
        subtitle: "After the bootcamp:",
      },
      {
        type: "bullets",
        items: [
          "Worked ~6 months in a startup",
          "Android / iOS app and the web side of the service (Next.js)",
          "Sound recognition → phones used as security sensors",
        ],
      },
      {
        type: "paragraphs",
        items: [
          "Unfortunately, the startup ran out of funding.",
          "I survived — startup didn’t 😄",
        ],
      },
    ],
  },
  {
    id: "payoneer",
    images: ["payoneer", "payoneerVolunteer", "useful"],
    blocks: [
      {
        type: "columns",
        left: [
          {
            type: "title",
            text: "Joining Payoneer",
            subtitle: "I joined Payoneer in early 2024 as a Customer Care agent:",
          },
          {
            type: "bullets",
            items: ["Chats", "Emails", "Phones"],
          },
        ],
        right: [
          {
            type: "title",
            text: "Achievements",
            subtitle: "With real paper certificates — very important 😄",
          },
          {
            type: "achievements",
            items: [
              "🏆 Agent of the Month — multiple times",
              "🏆 Agent of the Year — once",
              "✅ “Exceeded expectations” 2025 end-of-year review by team leader",
            ],
          },
        ],
      },
    ],
  },
  {
    id: "digital-ai",
    images: ["digitalAi"],
    blocks: [
      {
        type: "title",
        text: "Digital & AI team",
      },
      {
        type: "paragraphs",
        items: [
          "Now I’m with you, my dear team, for about 4 months already. Hope you enjoy it.",
          "I QA support bots (chat & email), with the perspective of someone who used to be the support agent.",
        ],
      },
    ],
  },
  {
    id: "useful",
    blocks: [
      {
        type: "title",
        text: "How I can be useful",
        subtitle:
          "I’d really appreciate the opportunity to grow within the platform area.",
      },
      {
        type: "paragraphs",
        items: ["I believe I can contribute:"],
      },
      {
        type: "bullets",
        items: ["As a QA ✅", "And with additional technical or platform-related tasks"],
      },
      {
        type: "paragraphs",
        items: [
          "Extra tooling / licenses could:",
          "Boost my productivity",
          "Boost team productivity",
          "Help when we’re short on people for different reasons",
        ],
      },
    ],
  },
  {
    id: "life-outside",
    images: ["lifeOutside", "lifeAnimals"],
    blocks: [
      {
        type: "title",
        text: "Life outside work",
        subtitle: "Some extra facts about me:",
      },
      {
        type: "bullets",
        items: [
          "Big animal lover since childhood",
          "My dog is from a shelter near Saint Petersburg — now Israeli too 🐶",
          "Sports: running, padel, beach volleyball, tennis, basketball, table tennis",
          "Music is still a big part of my life",
        ],
      },
    ],
  },
  {
    id: "close",
    images: ["funClose"],
    blocks: [
      {
        type: "title",
        text: "Fun facts & close",
      },
      {
        type: "columns",
        left: [
          {
            type: "bullets",
            items: [
              "My only tattoo says “dog friendly”",
              "My wife and I have a 30 cm height difference",
            ],
          },
        ],
        right: [
          {
            type: "bullets",
            items: [
              "🌱 Vegetarian for 12 years",
              "I already work on my personal MacBook 😉",
            ],
          },
        ],
      },
      {
        type: "links",
        title: "Music videos",
        links: [
          {
            label: "Händel — Lascia ch’io pianga",
            href: "https://youtu.be/jhd5vyxUNrQ",
          },
          {
            label: "Performance at the Capella, April 17, 2016",
            href: "https://youtu.be/3-j4OCcTItQ",
          },
          {
            label: "“Ты не такая”, Kosmos",
            href: "https://youtu.be/N-dyrTqY3Ek",
          },
        ],
      },
    ],
  },
];
